import React, { Component } from "react";
import "./styles.css";
import PropTypes from "prop-types";
import { EMPTY_STRING } from "../../../../constants";
import { capitalizeFirstLetter } from "../../../../helpers/helpers";

export default class NavCubeButton extends Component {
    render() {
        let selected = this.props.isCurrentOrientation ? "selected" : "";

        return (
            <div
                id={`nav-cube-${this.props.orientation}`}
                className={`nav-cube-modal-button ${selected}`}
                onClick={() => {
                    if (!this.props.isCurrentOrientation) {
                        this.props.handleClick(this.props.orientation);
                    }
                }}
            >
                {this.props.icon}
                <p className="text-center text-white">
                    {this.props.label ||
                        capitalizeFirstLetter(this.props.orientation)}
                </p>
            </div>
        );
    }
}

NavCubeButton.propTypes = {
    isCurrentOrientation: PropTypes.bool,
    orientation: PropTypes.string,
    handleClick: PropTypes.func,
    label: PropTypes.string,
    icon: PropTypes.node,
};

NavCubeButton.defaultProps = {
    isCurrentOrientation: false,
    orientation: EMPTY_STRING,
};
